/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTransactionsReport200ResponseInner
 */
export interface GetTransactionsReport200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    tabCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    tabName: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    type: GetTransactionsReport200ResponseInnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    charged: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    income: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    commission: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    commissionPercentage: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    commissionPercentageNumber: string;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    cardPercentageFee: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    cardPercentageFeeNumber: string;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    fixedFee: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    feeTax: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsReport200ResponseInner
     */
    transactionCost: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    status: GetTransactionsReport200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsReport200ResponseInner
     */
    payoutId?: string;
}


/**
 * @export
 */
export const GetTransactionsReport200ResponseInnerTypeEnum = {
    Payment: 'payment',
    Refund: 'refund'
} as const;
export type GetTransactionsReport200ResponseInnerTypeEnum = typeof GetTransactionsReport200ResponseInnerTypeEnum[keyof typeof GetTransactionsReport200ResponseInnerTypeEnum];

/**
 * @export
 */
export const GetTransactionsReport200ResponseInnerStatusEnum = {
    Waiting: 'waiting',
    Scheduled: 'scheduled',
    Sent: 'sent'
} as const;
export type GetTransactionsReport200ResponseInnerStatusEnum = typeof GetTransactionsReport200ResponseInnerStatusEnum[keyof typeof GetTransactionsReport200ResponseInnerStatusEnum];


/**
 * Check if a given object implements the GetTransactionsReport200ResponseInner interface.
 */
export function instanceOfGetTransactionsReport200ResponseInner(value: object): value is GetTransactionsReport200ResponseInner {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('tabCode' in value) || value['tabCode'] === undefined) return false;
    if (!('tabName' in value) || value['tabName'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('charged' in value) || value['charged'] === undefined) return false;
    if (!('income' in value) || value['income'] === undefined) return false;
    if (!('commission' in value) || value['commission'] === undefined) return false;
    if (!('commissionPercentage' in value) || value['commissionPercentage'] === undefined) return false;
    if (!('commissionPercentageNumber' in value) || value['commissionPercentageNumber'] === undefined) return false;
    if (!('cardPercentageFee' in value) || value['cardPercentageFee'] === undefined) return false;
    if (!('cardPercentageFeeNumber' in value) || value['cardPercentageFeeNumber'] === undefined) return false;
    if (!('fixedFee' in value) || value['fixedFee'] === undefined) return false;
    if (!('feeTax' in value) || value['feeTax'] === undefined) return false;
    if (!('transactionCost' in value) || value['transactionCost'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function GetTransactionsReport200ResponseInnerFromJSON(json: any): GetTransactionsReport200ResponseInner {
    return GetTransactionsReport200ResponseInnerFromJSONTyped(json, false);
}

export function GetTransactionsReport200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTransactionsReport200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'entityId': json['entityId'],
        'tabCode': json['tabCode'],
        'tabName': json['tabName'],
        'source': json['source'],
        'type': json['type'],
        'charged': json['charged'],
        'income': json['income'],
        'commission': json['commission'],
        'commissionPercentage': json['commissionPercentage'],
        'commissionPercentageNumber': json['commissionPercentageNumber'],
        'cardPercentageFee': json['cardPercentageFee'],
        'cardPercentageFeeNumber': json['cardPercentageFeeNumber'],
        'fixedFee': json['fixedFee'],
        'feeTax': json['feeTax'],
        'transactionCost': json['transactionCost'],
        'status': json['status'],
        'payoutId': json['payoutId'] == null ? undefined : json['payoutId'],
    };
}

export function GetTransactionsReport200ResponseInnerToJSON(json: any): GetTransactionsReport200ResponseInner {
    return GetTransactionsReport200ResponseInnerToJSONTyped(json, false);
}

export function GetTransactionsReport200ResponseInnerToJSONTyped(value?: GetTransactionsReport200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'entityId': value['entityId'],
        'tabCode': value['tabCode'],
        'tabName': value['tabName'],
        'source': value['source'],
        'type': value['type'],
        'charged': value['charged'],
        'income': value['income'],
        'commission': value['commission'],
        'commissionPercentage': value['commissionPercentage'],
        'commissionPercentageNumber': value['commissionPercentageNumber'],
        'cardPercentageFee': value['cardPercentageFee'],
        'cardPercentageFeeNumber': value['cardPercentageFeeNumber'],
        'fixedFee': value['fixedFee'],
        'feeTax': value['feeTax'],
        'transactionCost': value['transactionCost'],
        'status': value['status'],
        'payoutId': value['payoutId'],
    };
}

